import { render } from "./NcrmEmailMarketingDashboardTab.vue?vue&type=template&id=06a28ab2&scoped=true"
import script from "./NcrmEmailMarketingDashboardTab.vue?vue&type=script&lang=js"
export * from "./NcrmEmailMarketingDashboardTab.vue?vue&type=script&lang=js"

import "./NcrmEmailMarketingDashboardTab.vue?vue&type=style&index=0&id=06a28ab2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a28ab2"]])

export default __exports__